import React from "react";
import moment from "moment";
import { cross } from "react-icons-kit/icomoon/cross";
import SvgIcon from "react-icons-kit";
const filterByDate = (obj, date) => {
  let filtered = {};
  Object.entries(obj).forEach(([key, value]) => {
    let filteredValue = value.filter((v) => v.plannerInfo && v.plannerInfo[date]);
    if (filteredValue && filteredValue.length > 0) {
      filtered[key] = filteredValue;
    }
  });
  return filtered;
};

export const CalendarPanel = ({
  workingDays,
  onDateClick,
  assetIdNameMap,
  groupedTests,
  onRemoveScheduledAsset,
  weekDays,
  showRemoveButtons,
}) => {
  return (
    <div
      style={{
        width: "100%",
        // height: "100%",
        borderLeft: "1px solid #ccc",
        padding: "10px",
      }}
    >
      {workingDays.map((date) => {
        let filteredTests = filterByDate(groupedTests, date);
        let assetLists = Object.keys(filteredTests);
        let fullDay = moment(date).format("dddd");
        let disable = weekDays ? weekDays.map((d) => d.toLowerCase()).includes(fullDay.toLowerCase()) : true;

        return (
          <div
            key={date}
            style={{
              marginBottom: "16px",
              background: disable ? "#f5f5f5" : "#fff", // dim background
              border: "1px solid #e0e0e0",
              borderRadius: "6px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
              overflow: "hidden",
              opacity: disable ? 0.5 : 1, // faded look
              pointerEvents: disable ? "none" : "auto", // no interaction
              transition: "background 0.2s",
            }}
            onClick={() => {
              if (!disable) onDateClick(date);
            }}
          >
            <div
              style={{
                background: " #424d5aff",
                color: "#fff",
                padding: "8px 12px",
                fontWeight: "bold",
                fontSize: "15px",
                cursor: "pointer",
                borderBottom: "1px solid #ccc",
              }}
            >
              {moment(date).format("ddd, MMM D, YYYY")}
            </div>

            {assetLists.length > 0 && (
              <div style={{ padding: "8px 12px" }}>
                <ul style={{ margin: 0, padding: 0, listStyle: "none" }}>
                  {assetLists.map((assetId) => {
                    const tests = groupedTests[assetId] || [];
                    return (
                      assetIdNameMap[assetId] && (
                        <li
                          key={assetId}
                          style={{
                            fontSize: "14px",
                            marginBottom: "6px",
                          }}
                        >
                          <div style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                            <strong>{assetIdNameMap[assetId]}</strong>

                            {showRemoveButtons && (
                              <button
                                onClick={(e) => {
                                  e.stopPropagation(); // prevent card click
                                  onRemoveScheduledAsset(date, assetId);
                                }}
                                style={{
                                  background: "transparent",
                                  border: "none",
                                  cursor: "pointer",
                                  color: "red",
                                  fontSize: "18px",
                                  padding: 0,
                                  lineHeight: 1,
                                  marginBottom: "4px",
                                }}
                                title="Remove asset from this date"
                              >
                                <SvgIcon icon={cross} size={12} />
                              </button>
                            )}
                          </div>

                          {tests.length > 0 && (
                            <ul
                              style={{
                                paddingLeft: "18px",
                                margin: "4px 0 0",
                                listStyle: "disc",
                              }}
                            >
                              {tests.map((test, idx) => (
                                <li key={idx} style={{ fontSize: "12px", color: "#555" }}>
                                  {test.title || "Untitled Test"}
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      )
                    );
                  })}
                </ul>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/PiScheduler/CalendarPanel.jsx